import styled from 'styled-components';

export const RelatedStyles = styled.div`
  color: ${({ theme }) => theme.colors.limedSpruce};
  margin-top: 40px;

  .hr {
    border-bottom: 1px solid #cccccc;
  }

  @media (max-width: 512px) {
    margin: 0;
  }
`;

export const Header = styled.div`
  font-size: ${({ theme }) => theme.fontSize.lg};
  margin-bottom: 16px;

  @media (max-width: 1024px) {
    padding: 0 17px 0px;
  }

  @media (max-width: 512px) {
    font-size: ${({ theme }) => theme.fontSize.xn};
    padding: 24px 8px 0px;
  }
`;
